<template>
  <div>
    <div style="width: 100vw; background-color: #f9f9f9; display: flex; flex-direction: row; justify-content: center; align-items: center;">
      <div :style="'margin-top: 50px; width: '+($store.getters.getScreenWidth < 1400 ? '98%' : '90%')+'; max-width: 1920px; display: flex; flex-direction: column; justify-content: flex-start; align-items: center;'">
      <span style="font-size: 22px; font-weight: 500;">
        Some of our esteemed clients
      </span>
      <div style="margin-top: 50px; margin-bottom: 50px; width: 100%; display: flex; flex-direction: row; justify-content: center; align-items: center; flex-wrap: wrap;">
          <img
            v-for="(data, index) in getClientList"
            :key="index" 
            :src="data.image" alt="easytailorapp" :style="{margin: '5%', width: data.width+'px'}">
      </div>
    </div>
    </div>
  </div>
</template>

<script>

export default {
    computed: {
      getClientList() {
        return [
          {image: 'https://etacdn.b-cdn.net/new-website/client-1.png', width: 150},
          {image: 'https://etacdn.b-cdn.net/new-website/client-2.png', width: 150},
          {image: 'https://etacdn.b-cdn.net/new-website/client-3.png', width: 150},
          {image: 'https://etacdn.b-cdn.net/new-website/client-4.png', width: 150},
          {image: 'https://etacdn.b-cdn.net/new-website/client-5.png', width: 250},
          {image: 'https://etacdn.b-cdn.net/new-website/client-6.png', width: 200},
        ]
      }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Home/Row3.vue